import React from 'react'
import Api from 'EurestoApi/Api'
import FicheContact from '../../Component/Fiche/FicheContact'
import Grid from '@material-ui/core/Grid/Grid'
import User from 'EurestoClass/User'

import Utils from 'EurestoFonction/Utils'

class Modif extends React.Component {

  state = {
    hasError: false
  }

  componentDidCatch (error, info) {
    this.setState({ hasError: error })
  }

  render () {
    const id = this.props.params.id
    let paramsSend = { 'id': id, 'requete': 'client', 'action': 'get' }

    if (this.state.hasError) {
      return <Grid container style={{ margin: 0, padding: 0, fontSize: 25, height: User.CalculHeight.getHeightWanted()  }} spacing={0} direction="column"
                   justify="center"
                   alignItems="center">{this.state.hasError}</Grid>
    }
    return (<div style={{ margin: 0, padding: 0, height: User.CalculHeight.getHeightWanted()  }} key={Utils.getRandomNumber()}>
      <Api props={this.props} method={'crm'} dataSend={paramsSend} template={get}/>
    </div>)
  }

}

class get extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      data: []
    }
  };

  componentDidMount () {
    let DATA = this.props.data
    this.setState({
      data: DATA
    })
  }

  render () {
    let dossier_id = undefined
    let action_id = undefined
    let UserTabSelected = undefined
    let classeur_id = undefined
    let forceUpdate = undefined
    let dossier_status = undefined
    if (this.props && this.props.location && this.props.location.state) {
      UserTabSelected = this.props.location.state.UserTabSelected
      dossier_id = this.props.location.state.dossier_id !== 'null' && this.props.location.state.dossier_id !== null && this.props.location.state.dossier_id
      action_id = this.props.location.state.action_id !== 'null' && this.props.location.state.action_id !== null && this.props.location.state.action_id
      classeur_id = this.props.location.state.classeur_id !== 'null' && this.props.location.state.classeur_id !== null && this.props.location.state.classeur_id
      dossier_status = this.props.location.state.dossier_status !== 'null' && this.props.location.state.dossier_status !== null && this.props.location.state.dossier_status
      forceUpdate = this.props.location.state.mode !== 'null' && this.props.location.state.mode !== null && this.props.location.state.mode

      dossier_id = dossier_id && typeof dossier_id === 'string' && parseInt(dossier_id) || dossier_id
      action_id = action_id && typeof action_id === 'string' && parseInt(action_id) || action_id
      classeur_id = classeur_id && typeof classeur_id === 'string' && parseInt(classeur_id) || classeur_id
      UserTabSelected = UserTabSelected && typeof UserTabSelected === 'string' && parseInt(UserTabSelected) || UserTabSelected
    }
    return (
      <FicheContact classeur_id={classeur_id} action_id={action_id} dossier_id={dossier_id} UserTabSelected={UserTabSelected || 0}
                    typeContact={this.props.data.results.type} dossier_status={dossier_status}
                    typeaction="update" data={this.props.data.results} forceUpdate={forceUpdate}/>
    )
  }
}

export default Modif





// WEBPACK FOOTER //
// ./app/App/Module/CRM/Page/Modification/index.js